
// Test data for Level 2 Fairway Wood Training

export const fairwayWoodTests = [
  {
    id: "fairwayWood-3",
    title: "Bois 3",
    description: "Autour d'un trou, sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez à l'aide de tees 4 cercles de 2, 4, 6, 10 m. Taper 10 balles avec les fers de votre choix vers une cible à 180 m, noter les points selon la précision.",
    icon: "🏌️‍♂️",
    distance: "180m"
  },
  {
    id: "fairwayWood-5",
    title: "Bois 5",
    description: "Autour d'un trou, sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez à l'aide de tees 4 cercles de 2, 4, 6, 10 m. Taper 10 balles avec les fers de votre choix vers une cible à 160 m, noter les points selon la précision.",
    icon: "🏌️‍♂️",
    distance: "160m"
  }
];
